import { render, staticRenderFns } from "./SurveySettings.vue?vue&type=template&id=00038ff8&scoped=true"
import script from "./SurveySettings.vue?vue&type=script&lang=js"
export * from "./SurveySettings.vue?vue&type=script&lang=js"
import style0 from "./SurveySettings.vue?vue&type=style&index=0&id=00038ff8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00038ff8",
  null
  
)

export default component.exports